// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundPage_wrapper__7yCzW","container":"NotFoundPage_container__nUyr5","customCol":"NotFoundPage_customCol__sgMTU"};